module.exports = __webpack_public_path__ + "static/media/Turing.26f5b701.png";